export default __webpack_public_path__ + "static/GilroySemiBold-3e8d25ad48bd003ce980862420952478.woff2";